import firebase from "firebase";
import Rebase from "re-base";

const config = {
    apiKey: "AIzaSyBGHzxfoqEGmB22vrOJ4w3TZSWtY3ClIjg",
    authDomain: "ongolf-calendar.firebaseapp.com",
    databaseURL: "https://ongolf-calendar.firebaseio.com",
    projectId: "ongolf-calendar",
    storageBucket: "ongolf-calendar.appspot.com",
    messagingSenderId: "564952802351"
  }
// Initialize Firebase
const app = firebase.initializeApp(config)
const base = Rebase.createClass(app.database())
const auth = app.auth()
const facebookAuthProvider = new firebase.auth.FacebookAuthProvider()
const googleAuthProvider = new firebase.auth.GoogleAuthProvider()

export { app,base,auth,facebookAuthProvider,googleAuthProvider }


// WEBPACK FOOTER //
// ./src/base.js